import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values  = { url: String }
  static targets = ["loading", "content"]

  connect() {
    this._handler = (e) => { if (e.detail?.tab === "files") this.load() }
    document.addEventListener("telemetry-tabs:activated", this._handler)

    // Load immediately if pane is already visible (Files is the default tab)
    if (!this.element.hidden) this.load()
  }

  disconnect() {
    document.removeEventListener("telemetry-tabs:activated", this._handler)
  }

  async load() {
    if (this._loaded) return
    this._loaded = true

    try {
      const resp = await fetch(this.urlValue, { headers: { "Accept": "text/html" } })
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
      const html = await resp.text()
      this.contentTarget.innerHTML = html
      this.contentTarget.hidden = false
    } catch (e) {
      this.contentTarget.innerHTML = `<p class="telemetry__empty">Failed to load: ${e.message}</p>`
      this.contentTarget.hidden = false
    } finally {
      this.loadingTarget.hidden = true
    }
  }
}
